import React from "react";

/**
 * Nexus Logo SVG component
 */
const NexusLogo = ({ className = "" }) => (
  <img
    className={`${className}`}
    src="/workcliff_logo.png"
    alt="WorkCliff Nexus Logo"
  />
);

export default NexusLogo;
